import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.34846 17.5C5.32331 17.5 5.29816 17.4967 5.27615 17.4902C5.12524 17.4477 5.03406 17.2873 5.07494 17.1303L8.78478 2.71846C8.82565 2.56141 8.97971 2.46981 9.13061 2.50907C9.28153 2.5516 9.36956 2.71191 9.33183 2.86895L5.62198 17.2808C5.5874 17.4117 5.47422 17.5 5.34846 17.5Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9385 17.5C10.9134 17.5 10.8882 17.4967 10.8662 17.4902C10.7153 17.4477 10.6273 17.2873 10.665 17.1303L14.3748 2.71846C14.4157 2.56141 14.5698 2.46981 14.7207 2.50907C14.8716 2.5516 14.9596 2.71191 14.9219 2.86895L11.2121 17.2808C11.1775 17.4117 11.0643 17.5 10.9385 17.5Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.1196 7.2792H2.78296C2.62576 7.2792 2.5 7.14833 2.5 6.98474C2.5 6.82116 2.62576 6.69029 2.78296 6.69029H17.1196C17.2768 6.69029 17.4026 6.82116 17.4026 6.98474C17.4026 7.14833 17.2768 7.2792 17.1196 7.2792Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.217 13.309H2.87724C2.72004 13.309 2.59428 13.1781 2.59428 13.0145C2.59428 12.8509 2.72004 12.72 2.87724 12.72H17.217C17.3742 12.72 17.5 12.8509 17.5 13.0145C17.5 13.1781 17.3742 13.309 17.217 13.309Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgHash);
export default ForwardRef;
